import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ToothMascot } from "./ToothMascot";

const LINES = ["Polishing tiny smiles...", "Chasing away sugar bugs...", "Counting little teeth..."];

const Bubbles = () => (
  <div className="absolute inset-x-0 top-6 flex justify-center gap-6">
    {[0, 0.4, 0.8, 1.2].map((d, i) => (
      <span key={i} className="bubble block h-4 w-4 rounded-full border-2 border-sky-300 bg-sky-100/70"
        style={{ animationDelay: `${d}s`, marginTop: i % 2 ? 14 : 0 }} />
    ))}
  </div>
);

const Brush = () => (
  <div className="animate-brush absolute -top-2 left-1/2 -ml-12 z-10">
    <svg width="96" height="28" viewBox="0 0 96 28" aria-hidden="true">
      <rect x="30" y="10" width="64" height="10" rx="5" fill="#38bdf8" stroke="#1e293b" strokeWidth="3" />
      <rect x="2" y="6" width="32" height="14" rx="4" fill="#fff" stroke="#1e293b" strokeWidth="3" />
      {[6, 12, 18, 24].map((x) => <rect key={x} x={x} y="0" width="4" height="8" rx="2" fill="#f5b82e" />)}
    </svg>
  </div>
);

export const Preloader = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem("tb_preloaded"));
  const [line, setLine] = useState(0);

  useEffect(() => {
    sessionStorage.setItem("tb_preloaded", "1");
    const t = setTimeout(() => setShow(false), 2300);
    const i = setInterval(() => setLine((l) => (l + 1) % LINES.length), 800);
    return () => { clearTimeout(t); clearInterval(i); };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="site-preloader" exit={{ opacity: 0, scale: 1.08 }} transition={{ duration: 0.45 }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#fffdf9] dot-bg">
          <div className="relative h-44 w-40">
            <Bubbles />
            <Brush />
            <div className="animate-squish absolute inset-x-0 top-8 mx-auto w-28"><ToothMascot className="w-28" /></div>
            <div className="animate-shadow absolute bottom-0 left-1/2 -ml-12 h-3 w-24 rounded-full bg-slate-900" />
          </div>
          <p className="font-display mt-6 text-2xl font-semibold text-[#0d9488]">
            Tooth<span className="text-[#f5b82e]">Buds</span>
          </p>
          <p data-testid="preloader-text" className="mt-1 h-6 text-sm font-semibold text-slate-500">{LINES[line]}</p>
          <div className="mt-4 h-3 w-48 overflow-hidden rounded-full border-2 border-slate-800 bg-white">
            <div className="h-full rounded-full bg-gradient-to-r from-[#38bdf8] via-[#0d9488] to-[#f5b82e]"
              style={{ animation: "load-bar 2.1s ease-in-out forwards" }} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
